import React from "react";

import clsx from "clsx";
import { ChevronRight } from "lucide-react";
import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";

type BackgroundColor = "gradientGold" | "solidGrey";

interface Props {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  buttonContent: JSX.Element | string;
  buttonColor: BackgroundColor;
  hasAdvancedHoverState: boolean;
  id: string;
}

// Hover states use the hover:enabled: prefix to match the specificity of the variant
// styles they replace, otherwise the variant's own hover background wins.
// The hover fill is a flat two-stop gradient rather than a background-color, so the
// background stays an image in both states - swapping image to color mid-transition flashes.
// Class names are spelled out in full because Tailwind only generates what it finds
// verbatim in source; interpolating a variant onto a shared string produces no CSS.
const BUTTON_COLOR_CLASSES: Record<BackgroundColor, string> = {
  gradientGold: clsx(
    "border-transparent bg-premium-gold-gradient",
    "hover:enabled:border-premium-gold-border hover:enabled:bg-premium-gold-flat",
    "focus-visible:bg-premium-gold-flat",
  ),
  solidGrey: clsx(
    "border-premium-gold-border bg-white",
    "hover:enabled:bg-white focus-visible:bg-white",
  ),
};

export const UpsellButton = ({
  className,
  onClick,
  buttonContent,
  buttonColor,
  hasAdvancedHoverState,
  id,
}: Props) => {
  return (
    <Button
      id={id}
      variant={ButtonVariant.TertiaryWhite}
      size="sm"
      onClick={onClick}
      className={clsx(
        "group h-9 flex-1 border px-4 text-black shadow-none",
        BUTTON_COLOR_CLASSES[buttonColor],
        className,
      )}
      rightIcon={
        hasAdvancedHoverState ? (
          <ChevronRight
            size={12}
            className="opacity-0 transition-opacity group-hover:opacity-100"
          />
        ) : undefined
      }
    >
      {buttonContent}
    </Button>
  );
};

export default UpsellButton;
